'use strict';

exports.__esModule = true;
exports['default'] = {
  redbox: {
    boxSizing: 'border-box',
    fontFamily: 'sans-serif',
    position: 'fixed',
    padding: 10,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: '100%',
    background: 'rgb(204, 0, 0)',
    color: 'white',
    zIndex: 9999,
    textAlign: 'left',
    fontSize: '16px',
    lineHeight: 1.2
  },
  message: {
    fontWeight: 'bold'
  },
  stack: {
    fontFamily: 'monospace',
    marginTop: '2em'
  },
  frame: {
    marginTop: '1em'
  },
  file: {
    fontSize: '0.8em',
    color: 'rgba(255, 255, 255, 0.7)'
  },
  linkToFile: {
    textDecoration: 'none',
    color: 'rgba(255, 255, 255, 0.7)'
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/redbox-react/lib/style.js
// module id = 2090
// module chunks = 0